import { useMemo } from 'react';
import Corn from 'assets/icons/corn.svg';
import Barley from 'assets/icons/barley_crop.svg';
import Wheat from 'assets/icons/wheat_crop.svg';
import Sunflower from 'assets/icons/sunflower_crop.svg';
import Soyabean from 'assets/icons/soyabean_crop.svg';
import { Skeleton } from 'syngenta-digital-cropwise-react-ui-kit';
import { CropConstants } from 'utils/constants/Crop';
import { TFunction } from 'i18next';

export const getCropIcon = (cropName: string | undefined) => {
  switch (cropName) {
    case 'corn':
    case 'silage corn':
    case 'summer corn':
      return Corn;
    case 'sunflower':
      return Sunflower;
    case 'barley':
      return Barley;
    case 'wheat':
      return Wheat;
    case 'soybeans':
      return Soyabean;
    default:
      return Corn;
  }
};

export const getCropName = (
  recommendationCW: any,
  recommendationCropwise: any,
  t: TFunction
): string => {
  const { crop_type: cropType, crop_id: cropId } = recommendationCW || {};
  if (cropType === CropConstants.BARLEY || cropType === CropConstants.HYBRID_BARLEY) {
    return t('Hyvido');
  }
  if (
    recommendationCropwise?.country === CropConstants.Brazil &&
    cropType?.toLowerCase() === CropConstants.CORN_SMALLCASE
  ) {
    return cropId === 1 ? t(CropConstants.WINTER_CORN) : t(CropConstants.SUMMER_CORN);
  } else {
    return t(
      `${cropType
        ?.split(' ')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')}`
    );
  }
};

export const useSkeletonLoader = () => {
  return useMemo(() => {
    return (
      <Skeleton
        active
        style={{ padding: '100px 64px 0px 64px' }}
        paragraph={{ rows: 4, width: '100%' }}
      />
    );
  }, []);
};
